import { render, staticRenderFns } from "./cabineType.vue?vue&type=template&id=b5249ba0"
import script from "./cabineType.vue?vue&type=script&lang=js"
export * from "./cabineType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports